export default {
  user: ({ user }) => user,
  isSignIn: ({ access_token }) => !!access_token,
  signInLoading: ({ sign_in_loading }) => sign_in_loading,
  signInError: ({ sign_in_error }) => sign_in_error,
  loginGuardData: ({ login_guard_data }) => login_guard_data,
  loginLockedData: ({ login_locked_data }) => login_locked_data,
  needRecaptchaV2: ({ need_recaptcha_v2 }) => need_recaptcha_v2,
};
